import { render, staticRenderFns } from "./PressPage.vue?vue&type=template&id=6605eec1"
import script from "./PressPage.vue?vue&type=script&lang=js"
export * from "./PressPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports